export enum PlaylistChoices {
  default = 'default',
  owned = 'owned',
}

export enum Sort {
  asc = 'asc',
  desc = 'desc',
}

export interface PrintData {
  id: string;
  supply: number;
  printPrice: string;
  nextPrintPrice: string;
  burnPrice: string;
  nextBurnPrice: string;
}

export interface Original {
  id: string;
  mintNumber: number;
  owner: string;
  print?: PrintData;
  contractAddress: string;
  attributes?: any;
  media: {
    image: string;
    animatedImage: string;
    animation: string;
    audio: string;
  };
}

export enum TokenType {
  original = 'original',
  print = 'print',
}

export interface OwnedToken {
  contractAddress: string;
  tokenId: string;
  balance: number;

  type: string;
  original: Original;
}

export enum DROP {
  genesis = 'genesis',
  enigma = 'enigma',
  futura = 'futura',
}

export enum COLLECTION_NAMES {
  genesis = 'genesis',
  enigma = 'enigma',
  futura = 'futura',
  mixpass = 'mixpass',
  wearable = 'wearable',
}

export enum Polling {
  fast = 8000,
  average = 15000,
  slow = 30000,
}

export interface IdToOriginal {
  [key: string]: Original;
}

export interface PairInfo {
  genesisId: string;
  enigmaId: string;
  enabled: boolean;
  pairId: number;
}

export interface StakeBalance {
  pair: number;
  enigma: number;
  genesis: number;
  staked: number;
  totalStaked: number;
}

export interface UserClaimInfo {
  index: number;
  amount: string;
  proof: string[];
}

export interface ERC20Token {
  address: string;
  decimals: number;
  symbol: string;
}
